import React from "react";
import styles from "./Footer.module.scss";
import Image from "next/image";

interface FooterBottomProps {
  className?: string;
}

const FooterBottom: React.FC<FooterBottomProps> = ({ className }) => (
  <section 
    className={`${styles["o-footer__bottom"]} ${className || ""}`}
    aria-labelledby="footer-bottom-title"
  >
    <div className={`${styles["c-footer-bottom"]} ${styles["u-text-center"]}`}>
      <div className={styles["c-footer-bottom__content"]}>
        <Image 
          src="/tkn_lnd_pg_assets/images/solflare-text-logo.svg" 
          alt="Solflare" 
          width={120} 
          height={32} 
          className={styles["c-footer-bottom__logo"]}
          priority={false}
          loading="lazy"
        />
        <div className={`${styles["u-mono-02"]} ${styles["u-uppercase"]}`}>
          <p id="footer-bottom-title">
            THE STRONGHOLD OF THE FREE<br />
            POPULATION 3,000,000+ . EST 2021
          </p>
        </div>
        <p className={styles["u-bold-10"]}>HOLD STRONG</p>
      </div>
      <div className={styles["c-footer-bottom__copy"]}>
        <p className={`${styles["u-mono-02"]} ${styles["u-uppercase"]}`}>
          Copyright ©{new Date().getFullYear()} Solflare.
        </p>
      </div>
    </div>
  </section>
);

export default FooterBottom; 